import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import {Email, LibraryBooks} from '@material-ui/icons';
// import ModalBox from './ModalBox';
import Theme from './theme';
import { MuiThemeProvider} from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    backgroundColor: "white",
    textAlign: "center",
    position: "fixed",
    left: "0",
    bottom: "0",
    width: "100%",
    borderTop: "Solid",
    borderTopColor: "#42a5f5",
  },
});

export default function Footer() {
  const classes = useStyles();
  const [value, setValue] = React.useState('recents');
  // const [openModal, setOpenModal] = React.useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // function handleCloseModal() {
  //   setOpenModal(false);
  // }

  // function openTerms() {   
  //     setOpenModal(true);
  // }

  function contactUs() {
    window.location.href = `mailto:${'programoptions@sd38.bc.ca'}`;
  }

  return (
    <>
    <MuiThemeProvider theme={Theme}>
      <div className={classes.root}>
      
      <BottomNavigation value={value} onChange={handleChange}  showLabels>
        {/* <BottomNavigationAction label="Terms" value="recents" icon={<LibraryBooks />} onClick={openTerms} /> */}
        <BottomNavigationAction label="Contact us" value="favorites" icon={<Email />} onClick={contactUs}/>
        {/* <BottomNavigationAction label="Our location" value="nearby" icon={<LocationOnIcon />} /> */}
      </BottomNavigation>   
      {/* <ModalBox message = {"© 2019 - Richmond School Board. More information can be found at www.sd38.bc.ca"} title={"Terms"} open={openModal} close={handleCloseModal} /> */}
      </div>
      </MuiThemeProvider>
    </>
  );
}